module.exports = __webpack_public_path__ + "static/media/recordings.b09320fa.svg";